// Modo de color de la interfaz: claro, oscuro o automático (sigue al sistema).
// Es una preferencia de cada navegador (localStorage); si no se puede leer, claro.
import { useEffect, useState } from 'react';

const KEY = 'portal_theme';
const MODES = ['light', 'dark', 'auto'];

export function getMode() {
  try {
    const m = localStorage.getItem(KEY);
    return MODES.includes(m) ? m : 'light';
  } catch {
    return 'light';
  }
}

const systemDark = () => window.matchMedia?.('(prefers-color-scheme: dark)').matches;

/** Aplica el modo en <html data-theme>. Se llama también antes del primer render. */
export function applyMode(mode = getMode()) {
  const resolved = mode === 'auto' ? (systemDark() ? 'dark' : 'light') : mode;
  document.documentElement.dataset.theme = resolved;
  return resolved;
}

export function useThemeMode() {
  const [mode, setModeState] = useState(getMode);

  useEffect(() => {
    applyMode(mode);
    if (mode !== 'auto' || !window.matchMedia) return undefined;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => applyMode('auto');
    mq.addEventListener?.('change', onChange);
    return () => mq.removeEventListener?.('change', onChange);
  }, [mode]);

  const setMode = (m) => {
    try { localStorage.setItem(KEY, m); } catch {}
    setModeState(m);
  };
  return [mode, setMode];
}
